import apiResource from '@/services/http/api/resource'
import router from '@/router'
import ROUTE_NAMES from '@/constants/routeNames'

const defaultState = () => {
  return {
    family: null,
    loader: null,
    donorLoader: null
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    getFamily: (state) => state.family,
    getLoader: (state) => state.loader,
    getDonorLoader: (state) => state.donorLoader
  },
  mutations: {
    setFamily(state, payload) {
      state.family = payload
    },
    setLoader(state, payload) {
      state.loader = payload
    },
    setDonorLoader(state, payload) {
      state.donorLoader = payload
    },
    clear(state) {
      state.family = defaultState().family
      state.loader = defaultState().loader
    }
  },
  actions: {
    getFamily(context, payload) {
      context.commit('setLoader', true)
      return apiResource
        .getFamily(payload)
        .then(({ data }) => {
          if (data.data.warehouse.length <= 0) {
            router.push({ name: ROUTE_NAMES.HOME })
            return null
          }
          context.commit('setFamily', data.data)
          return data.data
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            router.replace({ name: ROUTE_NAMES.NOT_FOUND })
          }
        })
        .finally(() => {
          context.commit('setLoader', false)
        })
    },
    getDonor(context, payload) {
      context.commit('setDonorLoader', true)
      return apiResource
        .getDonor(payload)
        .then(({ data }) => {
          return data.data
        })
        .finally(() => {
          context.commit('setDonorLoader', false)
        })
    }
  }
}
